<script>
import KeenSlider from 'keen-slider'
import 'keen-slider/keen-slider.min.css'
import Spinner from '@/components/atoms/Spinner'
import { mapGetters } from 'vuex'

export default {
    name: 'Swiper',
    components: {
        Spinner,
    },
    props: {
        loaded: null,
        breakpoints: Object,
        topNav: Boolean,
        update: {
            type: [String, Number],
            dafeult: undefined,
        },
    },
    data() {
        return {
            isBeginning: true,
            isEnd: true,
            swiper: null,
        }
    },
    computed: {
        ...mapGetters(['smDevice', 'lgDevice']),
        isLoaded() {
            return this.loaded !== null && this.loaded !== undefined
                ? this.loaded
                : Boolean(this.$slots.default)
        },
        options() {
            return {
                loop: false,
                mode: this.smDevice ? 'free-snap' : 'snap',
                slides: {
                    perView: 'auto',
                    spacing: 8,
                },
                detailsChanged: this.onChange,
            }
        },
        hideNav() {
            return this.topNav && this.isEnd && this.isBeginning
        },
    },
    watch: {
        isLoaded: {
            immediate: true,
            handler(isLoaded) {
                if (isLoaded) {
                    this.$nextTick(() => {
                        this.swiper = new KeenSlider(this.$refs.swiper, this.options)
                    })
                }
            },
        },
        update: {
            handler(value, valueBefore) {
                if (this.swiper && value !== valueBefore) this.$nextTick(this.swiper.update)
            },
        },
    },
    beforeDestroy() {
        if (this.swiper) this.swiper.destroy()
    },
    methods: {
        next() {
            this.swiper.next()
        },
        prev() {
            this.swiper.prev()
        },
        onChange(swiper) {
            this.isBeginning = swiper.track.details.minIdx === swiper.track.details.rel
            this.isEnd = swiper.track.details.maxIdx === swiper.track.details.rel
        },
    },
    render(h) {
        const buttonPrev = h(
            'button',
            {
                class: [
                    'btn',
                    'step-prev',
                    {
                        disabled: this.isBeginning,
                        'opacity-0': this.isBeginning && !this.topNav,
                    },
                ],
                on: { click: this.prev },
            },
            [h('icon', { attrs: { icon: 'fa-solid fa-angle-left' } })]
        )
        const buttonNext = h(
            'button',
            {
                class: [
                    'btn',
                    'step-next',
                    {
                        disabled: this.isEnd,
                        'opacity-0': this.isEnd && !this.topNav,
                    },
                ],
                on: { click: this.next },
            },
            [h('icon', { attrs: { icon: 'fa-solid fa-angle-right' } })]
        )
        return h(
            'div',
            {
                class: [
                    'container-swiper',
                    { stretch: this.smDevice, 'top-nav': this.topNav && !this.hideNav },
                ],
            },
            [
                this.$slots.title
                    ? h(
                          'div',
                          {
                              class: 'swiper-title',
                          },
                          [this.$slots.title]
                      )
                    : null,
                this.isLoaded
                    ? h(
                          'div',
                          {
                              class: ['keen-slider'],
                              ref: 'swiper',
                          },
                          [
                              this.$slots.default
                                  ? this.$slots.default.map((el) => {
                                        return h(
                                            'div',
                                            {
                                                class: 'keen-slider__slide',
                                            },
                                            [el]
                                        )
                                    })
                                  : null,
                          ]
                      )
                    : h('spinner'),
                this.lgDevice && !this.hideNav ? buttonPrev : null,
                this.lgDevice && !this.hideNav ? buttonNext : null,
            ]
        )
    },
}
</script>
